import React from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import "./index.css";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  Line,
  Tooltip,
  Legend,
  CartesianGrid,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";
import DotsComponent from "./DotsComponent";

const data = [
  {
    name: "Jan",
    uv: -4000,
    pv: 2400,
    cv: 4000,
    amt: 2400,
  },
  {
    name: "Feb",
    uv: -3000,
    pv: 1398,
    cv: 3500,
    amt: 2210,
  },
  {
    name: "Mar",
    uv: -2000,
    pv: 9800,
    cv: 3000,
    amt: 2290,
  },
  {
    name: "Apr",
    uv: -2780,
    pv: 3908,
    cv: 2000,
    amt: 2000,
  },
  {
    name: "May",
    uv: -1890,
    pv: 4800,
    cv: 1500,
    amt: 2181,
  },
  {
    name: "June",
    uv: -2390,
    pv: 3800,
    cv: 1500,
    amt: 2500,
  },
  {
    name: "July",
    uv: -3490,
    pv: 4300,
    cv: 3200,
    amt: 2100,
  },
  {
    name: "Aug",
    uv: -3090,
    pv: 4300,
    cv: 2200,
    amt: 2100,
  },
  {
    name: "Sep",
    uv: -3090,
    pv: 4000,
    cv: 2000,
    amt: 2100,
  },
  {
    name: "Oct",
    uv: -2000,
    pv: 1100,
    cv: 1200,
    amt: 2100,
  },
  {
    name: "Nov",
    uv: -1300,
    pv: 1400,
    cv: 2200,
    amt: 2100,
  },
  {
    name: "Dec",
    uv: -1400,
    pv: 1100,
    cv: 3200,
    amt: 2100,
  },
];

var incoming = 0;
data.map((data) => {
  return (incoming += data.pv);
});

var outgoing = 0;
data.map((data) => {
  outgoing += data.uv;
  return outgoing;
});
outgoing = outgoing * -1;

var profit = incoming - outgoing;

export default function AccGraphRender() {
  return (
    <>
   
    <div className="cash-flow">
    
      <ResponsiveContainer aspect={2} >
        <ComposedChart
          data={data}
          stackOffset="sign"
          margin={{
            top: 0,
            right: 20,
            left: 10,
            bottom: 0,
          }}
        >
          <CartesianGrid horizontal={true} vertical={false} />
          <XAxis dataKey="name" style={{ fontSize: "10" }} />
          <YAxis style={{ fontSize: "10" }} />
          <Tooltip />
          <Legend />
          <ReferenceLine y={0} stroke="#000" />
          <Bar dataKey="pv" fill="#394A7E" stackId="stack" />
          <Bar dataKey="uv" fill="#F7762E" stackId="stack" />
          <Line
            type="linear"
            dataKey="cv"
            stroke="#20BF55"
            strokeWidth={2}
            activeDot={{ r: 8 }}
            legendType="none"
            hide={false}
            dot={true}
          />
        </ComposedChart>
      </ResponsiveContainer>
      <div className="chart-output">
        <h1 style={{ fontWeight: "500", fontSize: "16px" }}>₹{incoming}</h1>
        <h4 style={{ color: "#394A7E", fontWeight: "400", fontSize: "12px" }}>
          Incoming
        </h4>
        <h1 style={{ fontWeight: "500", marginTop: "60%", fontSize: "16px" }}>
          ₹{outgoing}
        </h1>
        <h4 style={{ color: "#F7762E", fontWeight: "400", fontSize: "12px" }}>
          Outgoing
        </h4>
        <h1 style={{ fontWeight: "500", marginTop: "60%", fontSize: "16px" }}>
          ₹{profit}
        </h1>
        <h4 style={{ color: "#20BF55", fontWeight: "400", fontSize: "12px" }}>
          Profit
        </h4>
      </div>
    </div>
    </>
  );
}
